import React, { FunctionComponent, useState } from 'react'
import { useRouter } from 'next/navigation'
import DarkButton from '@/components/ui/Buttons/SecondaryButton'
import useIntl from '@/utils/intl'
import { useMobiApi } from '@/services/mobi-api'
import ButtonLoader from '@/components/ui/buttonLoader'
import { resolveImageUrl } from '@/utils/constants'

interface Props {
  onClick: () => void
  danRedirectUrl: string
  errorType?: 'BLACKLIST' | 'UNDERAGE' | 'VERIFICATION_FAILED' | 'REGISTER_MISMATCH_DTI'
  errorMessage?: string
}

const EMongoliaFail: FunctionComponent<Props> = ({
  onClick,
  danRedirectUrl,
  errorType
}) => {
  const router = useRouter()
  const { translate } = useIntl()
  const { handset } = useMobiApi()
  const [loading, setLoading] = useState(false)

  const retryInsurance = async (): Promise<void> => {
    try {
      if (loading) {
        return
      }
      setLoading(true)
      const res = await handset.retry()
      if (res === true) {
        onClick()
      }
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const contentMap = {
    BLACKLIST: {
      image: resolveImageUrl('/uploads/icons/handset_fail_web.svg'),
      description: translate('leasing.blacklist.description')
    },
    UNDERAGE: {
      image: resolveImageUrl('/uploads/icons/handset_fail_web.svg'),
      description: translate('leasing.underage.description')
    },
    VERIFICATION_FAILED: {
      image: resolveImageUrl('/uploads/icons/handset_fail_web.svg'),
      description: translate('leasing.verification_failed.description')
    },
    REGISTER_MISMATCH_DTI: {
      image: resolveImageUrl('/uploads/icons/handset_fail_web.svg'),
      description: translate('leasing.register.mismatch.description')
    }
  } as const

  type ContentKey = keyof typeof contentMap

  const content =
    errorType !== undefined &&
    (Object.keys(contentMap) as ContentKey[]).includes(errorType)
      ? contentMap[errorType]
      : null

  // const handleContinue = async (): Promise<void> => {
  // if (!danRedirectUrl) {
  //   console.error('danRedirectUrl is missing')
  //   alert(translate('leasing.dan_url_missing'))
  //   return
  // }

  // const returnUrl = encodeURIComponent(
  //   `${window.location.origin}${window.location.pathname}?step=2&externalSuccess=true`
  // )
  // const redirectUrlWithReturn =
  //   danRedirectUrl +
  //   (danRedirectUrl.includes('?') ? '&' : '?') +
  //   `returnUrl=${returnUrl}`

  // console.log('Redirecting to DAN URL:', redirectUrlWithReturn)
  // onClick({ danUrl: danRedirectUrl })
  // router.push(redirectUrlWithReturn)
  // }
  const exitWebview = (): void => {
    let webView
    if ((window as any).mobiBridge !== undefined) {
      webView = (window as any).mobiBridge
    }
    if ((window as any).ReactNativeWebview !== undefined) {
      webView = (window as any).ReactNativeWebview
    }
    if (webView !== undefined) {
      const data = { key: 'exit' }
      webView.postMessage(JSON.stringify(data))
    } else {
      router.push('/')
    }
  }

  const handleButtonClick = async (): Promise<void> => {
    if (errorType === 'VERIFICATION_FAILED') {
      await retryInsurance()
    } else {
      exitWebview()
    }
  }

  return (
    <div className='bg-surfaceInverse rounded-xl md:shadow w-full h-full md:h-[40vh] md:w-fit flex flex-col justify-start relative no-scrollbar'>
      <div className='flex-grow px-4 py-4 sm:px-8 sm:py-8 overflow-auto no-scrollbar flex flex-col gap-4 mt-40 sm:mt-0'>
        <div className='flex items-center justify-center'>
          <img
            src={content?.image}
            className='w-[64px] h-[64px]'
            alt={errorType?.toLowerCase() ?? 'error'}
          />
        </div>
        <span className='text-textMid text-sm text-center whitespace-pre-line'>
          {content?.description}
        </span>
      </div>

      <div className='fixed md:sticky bottom-0 rounded-b-xl right-0 left-0 z-50 md:p-6 p-4 border-t bg-surfaceInverse border-secondaryMidStroke'>
        <div className='md:w-96 w-full flex'>
          <DarkButton
            fullwidth
            onClick={() => { void handleButtonClick() }}
            disabled={loading}
          >
            {loading
              ? <ButtonLoader />
              : errorType === 'REGISTER_MISMATCH_DTI'
                ? translate('leasing.fail')
                : errorType === 'VERIFICATION_FAILED'
                  ? translate('leasing.verification_failed.button')
                  : translate('continue')}
          </DarkButton>

        </div>
      </div>
    </div>
  )
}

export default EMongoliaFail
